// Display labels for positional numbers (BLD-15). Numbers come from the database (db/migrations/0004_numbering.sql);
// null means archived, which carries no number.
export const krLabel = (n: number | null | undefined) => (n ? `KR${n}` : "KR");
export const initiativeLabel = (n: number | null | undefined) => (n ? `Iniciativa ${n}` : "Iniciativa");
export const objectiveLabel = (n: number | null | undefined) => (n ? `Objetivo ${n}` : "Objetivo");
export const axisLabel = (n: number | null | undefined) => (n ? `Eixo ${n}` : "Eixo");
export const actionLabel = (n: number) => `Ação ${n}`;
